import request from '@/utils/request'

// 查询维修首页列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/layout/page',
        method: 'get',
        params: query,
    })
}
// 查询维修首页详细
export function getObj(id) {
    return request({
        url: '/upkeep/layout/detail?id=' + id,
        method: 'get',
    })
}
// 新增维修首页
export function addObj(data) {
    return request({
        url: '/upkeep/layout/add',
        method: 'post',
        data: data,
    })
}
// 禁用启用 维修首页状态
export function statusObj(data) {
    return request({
        url: '/upkeep/layout/status',
        method: 'post',
        data: data,
    })
}
// 修改维修首页
export function putObj(data) {
    return request({
        url: '/upkeep/layout/edit',
        method: 'post',
        data: data,
    })
}
// 删除维修首页
export function delObj(data) {
    return request({
        url: '/upkeep/layout/delete',
        method: 'post',
        data: data,
    })
}
